import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** The selectable tabs on the Finance → Invoices page. */
export type InvoiceTab = 'approval' | 'create' | 'summary';

export const INVOICE_TABS: readonly InvoiceTab[] = ['approval', 'create', 'summary'];

interface InvoiceViewState {
  /** Active tab. */
  currentTab: InvoiceTab;
  /** Group-by-customer vs flat "all orders" — shared across the tabs. */
  grouped: boolean;
  setCurrentTab: (tab: InvoiceTab) => void;
  setGrouped: (grouped: boolean) => void;
}

/**
 * Persists the Invoices view preferences (active tab + group/flat toggle) so a
 * refresh / return visit lands the user back on the same tab and layout. All
 * three tabs live under the single `/finance/invoicing` route, so the URL can't
 * carry this — it's stashed in localStorage (same idea as the Work View store).
 */
export const useInvoiceViewStore = create<InvoiceViewState>()(
  persist(
    (set) => ({
      currentTab: 'approval',
      grouped: true,
      setCurrentTab: (currentTab) => set({ currentTab }),
      setGrouped: (grouped) => set({ grouped }),
    }),
    {
      name: 'my:tms:invoiceView',
      partialize: (s) => ({ currentTab: s.currentTab, grouped: s.grouped }),
    },
  ),
);
